export default __webpack_public_path__ + "static/media/landing_search.e22910d7.gif";